/**
 * @file reducers/index.js
 * @location src/store/reducers/index.js
 * @role 도메인별 액션 핸들러를 단일 맵으로 병합 → useAppStore.js 의 reducer 가 위임
 */
import { navActions }         from './navActions.js';
import { taskActions }        from './taskActions.js';
import { autoActions }        from './autoActions.js';
import { templateActions }    from './templateActions.js';
import { memberActions }      from './memberActions.js';
import { uiActions }          from './uiActions.js';
import { syncActions }        from './syncActions.js';
import { outboxHandlers }     from './outboxActions.js';

export const handlers = {
  ...navActions,
  ...taskActions,
  ...autoActions,
  ...templateActions,
  ...memberActions,
  ...uiActions,
  ...syncActions,
  ...outboxHandlers,
};
